




































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseInput from '@shared/components/@atoms/BaseInput/BaseInput.vue';

export default defineComponent({
  name: 'BaseQuantitySelector',
  inject: {
    components: {
      default: {
        BaseInput,
        BaseButton,
      },
    },
  },
  model: {
    prop: 'qty',
  },
  props: {
    qty: {
      type: [Number, String],
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: 'Quantity',
    },
  },
  data(...args): any {
    return args;
  },
  // @ts-ignore migrated from ui-library
  handleInput(qty, listeners, min, max) {
    // adjust qty per min/max if needed
    const minimum = min || 1;
    if (qty < minimum || isNaN(qty)) {
      qty = minimum;
    } else if (max !== null && qty > max) {
      qty = max;
    }
    return listeners.input && listeners.input(qty);
  },
  // @ts-ignore migrated from ui-library
  handleBlur(listeners) {
    return listeners.blur && listeners.blur();
  },
  uniqueKey() {
    const key = Math.random().toString(16).slice(2);
    return `quantitySelector${key}`;
  },
});
